import carouselImage1 from '@/assets/images/news/hot/hot1.jpg';
import carouselImage2 from '@/assets/images/news/hot/hot2.jpg';
import carouselImage3 from '@/assets/images/news/hot/hot3.jpg';
import carouselImage4 from '@/assets/images/news/hot/hot4.jpg';
import carouselImage5 from '@/assets/images/news/hot/hot5.jpg';
import carouselImage6 from '@/assets/images/news/hot/hot6.jpg';
import carouselImage7 from '@/assets/images/news/hot/hot7.jpg';
import carouselImage8 from '@/assets/images/news/hot/hot8.jpg';
import carouselImage9 from '@/assets/images/news/hot/hot9.png';
import carouselImage10 from '@/assets/images/news/hot/hot10.jpg';

// 2022年11月30日更新
const data: Array<any> = [
  {
    image: carouselImage1,
    id: '20210415',
    link: 'http://wenhui.whb.cn/zhuzhanapp/cs/20220118/444679.html',
    time: '#文汇报 2022-01-18',
    title: '上海海洋大学“叮咚买菜奖教奖学金”获奖名单公布，校企携手助力研究成果落地',
    text:
      '近日，上海海洋大学公布了2021年度“叮咚买菜奖教奖学金”获奖名单。获奖的8位上海海洋大学师生，多为在水产与生命科学领域深耕多年的研究人员，他们的数项研究成果目前在与叮咚买菜的交流合作中，从实验室走向了江河湖海，最终为消费者的餐桌升级增添新美味。',
  },
  {
    image: carouselImage2,
    id: '20220215',
    link:
      'https://finance.sina.com.cn/tech/2022-02-15/doc-ikyamrna0943815.shtml',
    time: '#TechWeb 2022-02-15',
    title: '叮咚买菜2021年Q4营收54.8亿元 上海地区实现盈利',
    text:
      '【TechWeb】2月15日消息，美股盘前，叮咚买菜对外发布了截至2021年12月31日的第四季度业绩报告，数据显示，叮咚买菜第四季度实现营收54.8亿元，同比去年同期增长72.0%。2021年营收为201.2亿元，同比增长77.5%。',
  },
  {
    image: carouselImage3,
    id: '20220316',
    link: 'https://m.thecover.cn/news_details.html?id=8864040&channelId=4',
    time: '#封面新闻 2022-03-16',
    title: '四川65岁独臂老人搭上叮咚买菜电商快车，种香椿走上致富路',
    text:
      '据了解，作为叮咚买菜乡村振兴“绿水青山”计划的重要品类，今年叮咚买菜大竹香椿产地直采规模将达到近1000万元。',
  },
  {
    image: carouselImage4,
    id: '20220601',
    link: 'https://app.bjtitle.com/8816/newshow.php?newsid=6167901&mood=wx&typeid=13&ntype=0',
    time: '#北京青年报 2022-06-01',
    title: '叮咚买菜打造儿童膳食一站式解决方案',
    text:
      '随着儿童科学膳食成为大众关注的焦点，北京青年报记者6月1日了解到，叮咚买菜“宝妈严选”儿童食品板块，再度升级“儿童食品入选标准2.0”，走到农产品源头，实现“从种子到餐桌”的完整可追溯供应链，并与营养师合作，为家长提供儿童膳食产品+内容+服务的一站式解决方案。',
  },
  {
    image: carouselImage5,
    id: '20220803',
    link:'https://m.bjnews.com.cn/detail/1659519361169926.html',
    time: '#新京报 2022-08-03',
    title: '叮咚买菜联合原产地打造国内首个现代化“梭子蟹产地仓”',
    text:
      '8月3日，岱山县政府、叮咚买菜与舟山市中浩水产食品公司共同参与了“叮咚买菜舟山梭子蟹基地”的挂牌仪式，首个“叮咚岛”正式落地舟山。该产地仓投资1.5亿元，有84个暂养池，可同时容纳30万斤梭子蟹的暂养需求。',
  },
  {
    image: carouselImage6,
    id: '20220920',
    link: 'https://www.zgswcn.com/cms/mobile_h5/wapArticleDetail.do?article_id=202209201631361065&contentType=article#',
    time: '#中国商报 2022-09-20',
    title: '线上线下跨界联动 叮咚买菜助力餐企将火锅大餐搬回家',
    text:
      '今年秋冬，叮咚买菜等各大平台重点打造“养生派”火锅，推出了“番茄牛尾火锅”“醉鸡煲火锅”“当归羊肉火锅”等数十款创新锅底，既是火锅又是滋补汤品，将品质和健康放在首位。同时，叮咚买菜今年和众多线下火锅知名品牌合作，将餐饮企业与生鲜电商进行优势嫁接，让消费者在家也能享受和火锅店一样的体验和正宗的口味。',
  },
  {
    image: carouselImage7,
    id: '20221013',
    link: 'https://m.mp.oeeee.com/a/BAAFRD000020221013730031.html?layer=3&share=chat&isndappinstalled=0&wxuid=ogVRcdBD_SZp1DHNB6Qg25_e7ai0&wxsalt=75c682',
    time: '#南方都市报 2022-10-13',
    title: '荒山改造迎丰收，叮咚买菜科学种植口感烟薯助农增收',
    text:
      '随着多地陆续迎来不同幅度的降温，不少街头已经飘起了炒货、烤红薯的香味。随着需求增加，十月以来，叮咚买菜红薯类商品销量对比上月已经增长了30%左右，其中更受欢迎的烟薯，销量增长已超40%。相关人员表示，随着大部分地区天气变冷，红薯等秋冬应季农产品的销量还会继续提升。',
  },
  {
    image: carouselImage9,
    id: '20221104',
    link:
      'https://nginx-mrsb.hzyun.com.cn/mrsb/site1/resource/app/template/router/index.html?data=eyJsaW5rSWQiOjAsImFydGljbGVUeXBlIjowLCJhcHBJZCI6MSwiaXNTaGFyZSI6MSwiYXJ0aWNsZUlkIjo1NDExNTgsInNpdGVJZCI6MSwiY29sSWQiOjY1LCJyb290VXJsIjoiaHR0cHM6Ly93YW4tbXJzYi5oenl1bi5jb20uY24ifQ==&appVersion=3.2.1&wxAppId=wxaec465d1db732af0',
    time: '#每日商报 2022-11-04',
    title: '叮咚买菜火锅料理师：食品工业催热火锅到家业务，宅家火锅也美味',
    text:
      '“火锅食材千千万，口味围绕锅底转”。生鲜电商叮咚买菜也在大力发展火锅业务，致力于将各地消费者喜欢的口味通过再次研发搬到叮咚买菜的平台上，送到全国各地的家庭餐桌上。',
  },
  {
    image: carouselImage8,
    id: '20221108',
    link: 'http://www.xfrb.com.cn/article/focus/16085335168647.html',
    time: '#消费日报 2022-11-08',
    title: '进博会助力叮咚买菜打造全球直采供应链新西兰鹿肉直供国民餐桌',
    text:
      '11月8日，进博会上，叮咚买菜与来自新西兰的银蕨农场签署战略协议，将从新西兰牧场直采草饲鹿肉、小公牛等优质红肉，直供中国消费者的餐桌，此次合作金额达5000万人民币。',
  },
  {
    image: carouselImage10,
    id: '20221118',
    link: 'https://wap.xinmin.cn/content/32267567.html',
    time: '#新民晚报 2022-11-18',
    title: '从源头管到餐桌，订单农业降低蔬菜农残风险',
    text:
      '记者昨天从叮咚买菜获悉，叮咚买菜上线了一批通过新型订单种植种出的“三优”系列蔬菜，从十几种易引发高农药残留风险的蔬菜品种入手，在源头选择优质基地和优良种植方式，最大化地降低残留风险。其中，豇豆作为首批上线的品类之一，已经在不同产区的轮转中完善了订单种植方案，实现了长期稳定供应。',
  },
];

export const carouselData = data.reverse();
